import { Box } from "@mui/material";
import React from "react";
import { WorkflowAppsType, WorkflowSuiteApps } from "../../../Types/Workflow-Types";
import { TextSuiteApps } from "../../../Helper";
import { TranslatorIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/TranslatorIcon";
import { HumanizeIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/HumanizeIcon";
import { SummarizeIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/SummarizeIcon";
import { ParaphraseIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/ParaphraseIcon";
import { PromptEngineerIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/PromptEngineerIcon";
import BlueCheckBoxIcon from "../../../Custom-imeges/BlueCheckBoxIcon";
import { ImageTranscaptionIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/ImageTranscaptionIcon";
import { Tooltip as MuiTooltip } from "@mui/material";

const WorkflowTextApps = ({
  apps,
  selectedItemData,
  returnLastSelectedApp,
  selectedSuiteType,
  handleSetActiveItem,
}: WorkflowSuiteApps) => {
const WorkflowAppsIcons: Partial<Record<WorkflowAppsType, JSX.Element>> = {
    [WorkflowAppsType.Translator]: <TranslatorIcon className="custom-icon" />,
    [WorkflowAppsType.Humanizer]: <HumanizeIcon className="custom-icon-stroke" />,
    [WorkflowAppsType.Summarizer]: <SummarizeIcon className="custom-icon" />,
    [WorkflowAppsType.Paraphraser]: <ParaphraseIcon className="custom-icon" />,
    [WorkflowAppsType.PromptGenerator]: <PromptEngineerIcon className="custom-icon" />,
    [WorkflowAppsType.TextExtraction]: <ImageTranscaptionIcon className="custom-icon" />,
  };
  return (
    <Box className="display-apps mt-2 mb-2">
      {apps
        ?.filter(
          (app) =>
            app.appType !== TextSuiteApps.TitleGenerator &&
            app.appType !== TextSuiteApps.AiDetector &&
            selectedSuiteType === app.suiteType
        )
        .map((app, i) => {
          const isCompatible =
            !returnLastSelectedApp ||
            returnLastSelectedApp.outputType === app.inputType;
          return (
            <Box
              key={i}
              className={`${
                !returnLastSelectedApp ||
                returnLastSelectedApp.outputType === app.inputType
                  ? "active-workflow-app"
                  : "inactive-workflow-app"
              }`}
              sx={{ display: "flex", alignItems: "center" }}
              onClick={() => isCompatible && handleSetActiveItem(app)}
            >
              <MuiTooltip
                title="This app’s input type doesn’t match the output of the previous step."
                placement="top"
                arrow
                disableHoverListener={isCompatible}
                componentsProps={{
                  tooltip: {
                    sx: {
                      bgcolor: "#E5E2E1",
                      color: "#0B1216",
                      fontFamily: "Inter",
                      fontSize: "11px",
                      fontWeight: 500,
                      lineHeight: "17px",
                      maxWidth: "160px",
                      borderRadius: "4px",
                      padding: "8px 12px",
                      gap: "8px",
                    },
                  },
                  arrow: {
                    sx: {
                      color: "#E5E2E1",
                    },
                  },
                }}
              >
                <Box
                  className={`text-nav-item workflow-nav-item m-0 ${app.appType?.toLowerCase()} app-workflow-item ${
                    selectedItemData.appType === app.appType && "active"
                  }`}
                  style={{ textDecoration: "none !important" }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                      { WorkflowAppsIcons[app.appType as WorkflowAppsType] }
                  </Box>
                  <span
                    className={`text-nav-item-name ${
                      selectedItemData.appType === app.appType && "active"
                    }`}
                    style={{ textDecoration: "none !important" }}
                  >
                    {app.appType}
                    {selectedItemData.appType === app.appType && (
                      <span className="ms-2">
                        <BlueCheckBoxIcon />
                      </span>
                    )}
                  </span>
                </Box>
              </MuiTooltip>
            </Box>
          );
        })}
    </Box>
  );
};

export default WorkflowTextApps;
